import { Box, Divider, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Link } from "react-router";

import { PageHero, PageSection, usePageTitle } from "../../components";

import { BLOG_POSTS } from "./consts/posts";

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString("nl-NL", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export const BlogOverview: FC = () => {
  usePageTitle("Blog");

  return (
    <Box>
      <PageHero
        title="Blog"
        subtitle="Nieuws, leuke projecten en 'how-to`s' over BRO-processen en grondwatermonitoring."
      />

      <PageSection>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {BLOG_POSTS.map((post) => (
            <Box
              key={post.slug}
              border="1px solid"
              borderColor="gray.100"
              rounded="large"
              overflow="hidden"
              boxShadow="sm"
              display="flex"
              flexDir="column"
              bg="white"
            >
              <Box p={7} flex="1">
                <Text fontSize="xs" fontWeight="400" color="gray.400" mb={3}>
                  {formatDate(post.date)}
                </Text>
                <Heading as="h2" fontSize="lg" color="text" mb={3} lineHeight="short">
                  {post.title}
                </Heading>
                <Divider mb={4} />
                <Text fontWeight="400" fontSize="sm" color="gray.600" lineHeight="tall">
                  {post.excerpt}
                </Text>
              </Box>
              <Box px={7} pb={7}>
                <Link to={`/public/blog/${post.slug}`} style={{ textDecoration: "none" }}>
                  <Text
                    fontSize="sm"
                    fontWeight="700"
                    color="primary"
                    display="inline-flex"
                    alignItems="center"
                    gap={1}
                  >
                    Lees meer →
                  </Text>
                </Link>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </PageSection>
    </Box>
  );
};
